import { Avatar } from '@/components/ui/Avatar';
import { cn } from '@/lib/utils';
import { inactiveAccountLabel, isInactiveAccount } from '@/lib/account-status';

type Person = { id: string; name: string; avatarUrl?: string | null; accountStatus?: string };

/**
 * An assignee's avatar. Someone suspended or removed in Accounts stays on the
 * task (history and reassignment need them) but renders dimmed with a red
 * dot, so whoever looks at the task knows to reassign it.
 */
export function AssigneeAvatar({
  person,
  size = 'xs',
  className,
}: {
  person: Person;
  size?: 'xs' | 'sm';
  className?: string;
}) {
  if (!isInactiveAccount(person.accountStatus)) {
    return <Avatar src={person.avatarUrl ?? undefined} name={person.name} size={size} className={className} />;
  }
  const label = inactiveAccountLabel(person.accountStatus);
  return (
    <span className="relative flex flex-shrink-0" title={`${person.name} (${label.toLowerCase()})`}>
      <Avatar src={person.avatarUrl ?? undefined} name={person.name} size={size} className={cn(className, 'opacity-50 grayscale')} />
      <span
        aria-label={label}
        className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-error ring-1 ring-white"
      />
    </span>
  );
}
